import { CREATE_COMMENT, DELETE_COMMENT, REPORT_COMMENT  } from "./../actions/types";

const initialState = {
    comments: {}
}

const commentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_COMMENT:
                return {
                    ...state,
                    type: CREATE_COMMENT,
                    comments: action.comments
                }
            break;
    
        case REPORT_COMMENT:
            return {
                ...state,
                comments: {
                    ...state.comments,
                    [action.payload.commentID]: action.payload
                }
            };
    case DELETE_COMMENT:
                return {
                    ...state,
                    type: DELETE_COMMENT,
                    comments: action.comments
                }
            break;
        default:
         return state
            break;
    }
}

export default commentsReducer;